import find from 'lodash.find';
import { createSelector } from 'reselect';

const getVehicles = (state) => state.vehicles;

export const getAllVehicles = createSelector(
  [getVehicles], (vehicles) => ({ vehicles }),
);

export const getSelectedVehicle = createSelector(
  [getVehicles], (vehicles) => {
    let selectedVehicle;

    if (vehicles.length > 0) {
      selectedVehicle = find(vehicles, { selected: true });
    }

    return { vehicle: selectedVehicle };
  },
);
